export default {
    shadow: 'rgba(0, 0, 0, 0.1)',
    title: '#222',
    info: '#555',
    paragraph: '#888',
    border: '#ddd',
    cardBackground: '#f1f1f1',
    white: '#FFF',
    black: '#000',
    successBackground: '#cdf4dd',
    successIcon: '#42a662',
    errorBackground: '#fbdddb',
    errorIcon: '#b13637'
};
